module.exports = __webpack_public_path__ + "img/c_5.d523cd0d.png";